<!-- HEADER -->
<header id="main-header" class="py-2 bg-primary text-white">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h1>
          <i class="fas fa-cog"></i> Dashboard</h1>
      </div>
    </div>
  </div>
</header>

<!-- ACTIONS -->
<section id="actions" class="py-4 mb-4 bg-light">
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <a class="btn btn-secondary btn-block mb-2 text-white" data-toggle="modal" data-target="#addSessionModal" (click)="onAddSessionClick()">
          <i class="fas fa-plus"></i> Add Session
        </a>
      </div>
      <!-- <div class="col-md-3">
        <a class="btn btn-success btn-block mb-2 text-white" data-toggle="modal" data-target="#addStudentModal" (click)="onAddStudentClick()">
          <i class="fas fa-plus"></i> Add Student
        </a>
      </div> -->
      <div class="col-md-4">
        <a class="btn btn-warning btn-block mb-2 text-white" data-toggle="modal" data-target="#addTutorModal" (click)="onAddTutorClick()">
          <i class="fas fa-plus"></i> Add Tutor
        </a>
      </div>
      <div class="col-md-4">
        <a class="btn btn-info btn-block mb-2 text-white" data-toggle="modal" data-target="#addSubAdminModal" (click)="onAddSubAdminClick()">
          <i class="fas fa-plus"></i> Add Sub-admin
        </a>
      </div>
    </div>
  </div>
</section>

<!-- CONTENT -->
<div class="container">
  <div class="row" style="border: 1px solid silver; padding: 10px;">

    <div class="row mb-1">
      <div class="col-4">
        <div class="py-2 bg-dark text-white text-center">
          <b>Latest Sessions</b>
        </div>
      </div>
      <div class="col-8">
        <div class="py-2 bg-dark text-white text-center">
          <b>Chatroom</b>
        </div>
      </div>
    </div>

    <!-- CHAT-WINDOW -->
    <div class="row chat-window">
      <div class="col-4 session-list bg-light">

        <a style="cursor: pointer;" *ngFor="let session of latestSessionList" (click)="onSessionSelect(session._id, session.status)">
          <div class="card my-2">
            <div class="card-body">
              <div class="row">
                <div class="col-7">
                  <h5 class="card-title">{{ session.sessionTopic }}</h5>
                  <h6 class="card-subtitle mb-2 text-muted">{{ session.startTime }}</h6>
                  <p class="card-text">{{ session.sessionCode }}</p>
                </div>
                <div class="col-5">
                  <b *ngIf="session.status=='UPCOMING'" style="color: blue; float: right;">Upcoming</b>
                  <b *ngIf="session.status=='LIVE'" style="color: green; float: right;"><i class="fa fa-circle" aria-hidden="true"></i> Live</b>
                  <b *ngIf="session.status=='COMPLETE'" style="float: right;;">Complete</b>
                </div>
              </div>
            </div>
          </div>
        </a>

      </div>
      <div class="col-8 chatroom">
        <div *ngIf="sessionSelected==false" class="instruction-div text-center mt-5">
          <h3>Click on a session to visit!</h3>
        </div>
        <app-ecachatroom *ngIf="sessionSelected==true"></app-ecachatroom>
      </div>
    </div>
  </div>

    <!-- NAVIGATION -->
  <div class="row mt-5">
    <!-- <div class="col-md-3"> -->
      <div class="col-md-3">
        <div class="card text-center bg-secondary text-white">
          <div class="card-body">
            <h3>Sessions</h3>
            <h4 class="display-4">
              <i class="fa fa-comments"></i> {{ counts.sessionCount }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-center bg-success text-white">
          <div class="card-body">
            <h3>Students</h3>
            <h4 class="display-4">
              <i class="fa fa-comments"></i> {{ counts.studentCount }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-center bg-warning text-white">
          <div class="card-body">
            <h3>Tutors</h3>
            <h4 class="display-4">
              <i class="fa fa-comments"></i> {{ counts.tutorCount }}
            </h4>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-center bg-info text-white">
          <div class="card-body">
            <h3>Sub-admins</h3>
            <h4 class="display-4">
              <i class="fa fa-comments"></i> {{ counts.subadminCount }}
            </h4>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>

</div>

<!-- FOOTER -->
<footer id="main-footer" class="bg-dark text-white mt-5 p-4 sticky-bottom">
  <div class="container">
    <div class="row">
      <div class="col text-center">
        <b>Ecademictube - Live Sessions</b>
        <p>Copyright © {{ currentYear }}. All rights reserved.</p>
      </div>
    </div>
  </div>
</footer>


<!-- Add Session Modal -->
<div class="modal fade" id="addSessionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-secondary text-white">
        <h5 class="modal-title" id="exampleModalLongTitle">Add New Session</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 650px; overflow-y: scroll;">
        <!-- Session Code -->
        <label><b>Session Code:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="sessionCode" disabled>
        </div>
        <!-- Session Date -->
        <label><b>Date:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="currentDate" disabled>
        </div>
        <!-- Session Start Time -->
        <label><b>Session Start Time:</b></label>
        <div class="row">
          <div class="col">
            <div class="input-group mb-3">
              <input type="number" class="form-control" [(ngModel)]="timeStartHours">
            </div>
          </div>
          :
          <div class="col">
            <div class="input-group mb-3">
              <input type="number" class="form-control" [(ngModel)]="timeStartMinutes">
            </div>
          </div>
          <div class="col">
            <div class="input-group">
              <select class="custom-select" [(ngModel)]="timeStartHalf">
                <option value="AM" selected>AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
        </div>
        <!-- Session End Time -->
        <label><b>Session End Time:</b></label>
        <div class="row">
          <div class="col">
            <div class="input-group mb-3">
              <input type="number" class="form-control" [(ngModel)]="timeEndHours">
            </div>
          </div>
          :
          <div class="col">
            <div class="input-group mb-3">
              <input type="number" class="form-control" [(ngModel)]="timeEndMinutes">
            </div>
          </div>
          <div class="col">
            <div class="input-group">
              <select class="custom-select" [(ngModel)]="timeEndHalf">
                <option value="AM" selected>AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
        </div>
        <!-- Topic -->
        <label><b>Topic:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="topic">
        </div>
        <!-- Description -->
        <label><b>Description:</b></label>
        <div class="input-group mb-3">
          <textarea class="form-control" rows="3" [(ngModel)]="description"></textarea>
        </div>
        <!-- Tutors -->
        <label><b>Select Tutors:</b></label>
        <div class="form-check" *ngFor="let tutor of tutorList">
          <input #checkboxes class="form-check-input" type="checkbox" value="Tutor 1" id="flexCheckDefault" (click)="onChecked(tutor._id)">
          <label class="form-check-label" for="flexCheckDefault">
            {{ tutor.name }}
          </label>
        </div>

         <!-- Sub Admin -->
         <label><b>Select Sub Admin:</b></label>
         <div class="form-check" *ngFor="let subAdmin of subAdminList">
           <input #checkboxes class="form-check-input" type="checkbox" value="Tutor 1" id="flexCheckDefault" (click)="onSubAdminChecked(subAdmin._id)">
           <label class="form-check-label" for="flexCheckDefault">
             {{ subAdmin.name }}
           </label>
         </div>


        <!-- <div class="form-check">
          <input class="form-check-input" type="checkbox" value="Tutor 2" id="flexCheckChecked" [(ngModel)]="selectedTutors.tutor2">
          <label class="form-check-label" for="flexCheckChecked">
            Tutor 2
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="Tutor 3" id="flexCheckChecked" [(ngModel)]="selectedTutors.tutor3">
          <label class="form-check-label" for="flexCheckChecked">
            Tutor 3
          </label>
        </div> -->
      </div>

      <!-- Errors and Alerts -->
      <div class="mx-2">
        <div class="alert alert-danger" role="alert" *ngIf="invalidTimeError">
          Please enter a valid time!
        </div>
        <div class="alert alert-danger" role="alert" *ngIf="emptyFieldError">
          Enter values in all fields!
        </div>
        <div class="alert alert-success" role="alert" *ngIf="sessionCreatedAlert">
          Session Created Successfully!
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCreateSession()">Create Session</button>
      </div>
    </div>
  </div>
</div>

<!-- Add Student Modal -->
<div class="modal fade" id="addStudentModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-success text-white">
        <h5 class="modal-title" id="exampleModalLongTitle">Add New Student</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <label><b>Student Code:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="studentData.code" disabled>
        </div>

        <label><b>Name:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="studentData.name">
        </div>

        <label><b>Email:</b></label>
        <div class="input-group mb-3">
          <input type="email" class="form-control" [(ngModel)]="studentData.email">
        </div>

        <label><b>Contact:</b></label>
        <div class="input-group mb-3">
          <input type="number" class="form-control" [(ngModel)]="studentData.contact">
        </div>

        <label><b>Class:</b></label>
        <div class="input-group mb-3">
          <input type="number" class="form-control" [(ngModel)]="studentData.class">
        </div>

        <label><b>School:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="studentData.school">
        </div>

        <label><b>Location:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="studentData.location">
        </div>
      </div>

      <!-- Errors and Alerts -->
      <!-- <div class="mx-2">
        <div class="alert alert-success" role="alert" *ngIf="studentCreatedAlert">
          Student Added Successfully!
        </div>
      </div> -->

      <!-- <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="onAddStudent()">Add</button>
      </div> -->
    </div>
  </div>
</div>

<!-- Add Tutor Modal -->
<div class="modal fade" id="addTutorModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-warning text-white">
        <h5 class="modal-title" id="exampleModalLongTitle">Add New Tutor</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <label><b>Tutor Code:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="tutorData.code" disabled>
        </div>

        <label><b>Name:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="tutorData.name">
        </div>

        <label><b>Email:</b></label>
        <div class="input-group mb-3">
          <input type="email" class="form-control" [(ngModel)]="tutorData.email">
        </div>

        <label><b>Contact:</b></label>
        <div class="input-group mb-3">
          <input type="number" class="form-control" [(ngModel)]="tutorData.contact">
        </div>

        <label><b>Location:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="tutorData.location">
        </div>

        <label><b>Qualification:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="tutorData.qualification">
        </div>
      </div>

      <!-- Errors and Alerts -->
      <div class="mx-2">
        <div class="alert alert-success" role="alert" *ngIf="tutorCreatedAlert">
          Tutor Added Successfully!
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-warning text-white" (click)="onAddTutor()">Add</button>
      </div>
    </div>
  </div>
</div>

<!-- Add Sub-admin Modal -->
<div class="modal fade" id="addSubAdminModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-info text-white">
        <h5 class="modal-title" id="exampleModalLongTitle">Add New Sub-admin</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <label><b>Name:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="subAdminData.name">
        </div>

        <label><b>Email:</b></label>
        <div class="input-group mb-3">
          <input type="email" class="form-control" [(ngModel)]="subAdminData.email">
        </div>

        <label><b>Password/Code:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="subAdminData.password" disabled>
        </div>

        <label><b>Contact:</b></label>
        <div class="input-group mb-3">
          <input type="number" class="form-control" [(ngModel)]="subAdminData.contact">
        </div>

        <label><b>Location:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="subAdminData.location">
        </div>

        <label><b>Qualification:</b></label>
        <div class="input-group mb-3">
          <input type="text" class="form-control" [(ngModel)]="subAdminData.qualification">
        </div>
      </div>

      <!-- Errors and Alerts -->
      <div class="mx-2">
        <div class="alert alert-success" role="alert" *ngIf="subAdminCreatedAlert">
          Sub-admin Added Successfully!
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-info" (click)="onAddSubAdmin()">Add</button>
      </div>
    </div>
  </div>
</div>
